import(/* webpackMode: "eager" */ "/data/web/oneroof-rebuild/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/breadcrumb/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageViewLayer"] */ "/data/web/oneroof-rebuild/src/app/_components/dataLayer/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(hubpage)/news/_modules/searchBar/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(hubpage)/news/[...slug]/@search/_list/content.js");
